module.exports = __webpack_public_path__ + "static/pdf.d179747e0f6783ef80a1bc66f43f5cc1.png";